module.exports = {
      id: "nok-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#nok-usage",
      toString: function () {
        return this.url;
      }
    }